export const blockIconsUiactionsArrowForwardiOSNew = (
	<span className='material-symbols-outlined'>arrow_forward_ios</span>
);
